import store from '@/store'
import { PACKAGE_VERSION } from '@/constants'
import { CustomEventType } from '@/constants/enum/CustomEventType'

if (process.env.NODE_ENV !== 'development') {
  window.addEventListener(CustomEventType.FoundNewVersion, ({ detail }: any) => {
    store.dispatch('system/setDeployedVersion', detail.deployedVersion)
  })
  const checkVersion = () =>
    fetch(`/version.json?current=${PACKAGE_VERSION}`, { cache: 'no-store' })
      .then((response) => response.json())
      .then((data) => {
        const deployedVersion = data?.version || PACKAGE_VERSION
        if (deployedVersion !== PACKAGE_VERSION) {
          window.dispatchEvent(new CustomEvent(CustomEventType.FoundNewVersion, { detail: { deployedVersion } }))
        }
      })
      .catch(() => {})
  checkVersion()
  setInterval(checkVersion, 60000)
}
